import { UploadedImage, AddressType } from '../../common/CommonTypes';

export type CosmeticErrors = {
    dateOfIncident?: string;
    mileage?: string;
    incidentOccured?: string;
    damageType?: string;
    damageDepth?: string;
    damageLength?: string;
    closeUpImage?: string;
    noCosmeticRequests?: string;
    distanceImage?: string;
    selectedPanels?: string;
    notAllowedPanels?: string;
};

export type CosmeticRepairRequestType = {
    id: number;
    productReference: string;
    dateOfIncident?: string;
    mileage?: string;
    incidentOccured?: string;
    damageType?: string;
    damageDepth?: string;
    damageLength?: string;
    uploadedImages: UploadedImage[];
    selectedPanels: Panels[];
};

export type DamageLengthOptions = {
    id: string;
    text: string;
    value: string;
    disabled: boolean;
};

export type CosmeticAddressErrors = {
    noRepairAddressSelected?: string;
};

export type CosmeticPageErrors = {
    cosmeticGeneral?: CosmeticErrors;
    cosmeticAddress?: CosmeticAddressErrors;
    permissionGranted?: string;
};

export type CosmeticPageState = {
    cosmeticStage: CosmeticProcessStages;
    cosmeticRepairRequests: CosmeticRepairRequestType[];
    currentRepairRequest?: CosmeticRepairRequestType;
    cosmeticFormError?: CosmeticPageErrors;
    hasErrors: boolean;
    repairRequestSelectedIndex: number;
    repairAddressSelectedIndex: number;
    repairAddresses: Array<AddressType>;
    scrollToAddress: boolean;
    showRepairRequestForm: boolean;
    isLoadingOnSubmission: boolean;
    permissionGranted: boolean;
    showCancelAlert: boolean;
    selectedPanels: Array<Panels>;
};

export enum CosmeticProcessStages {
    General,
    RepairAddress,
    Summary
}

export const ReducerActionNames = {
    SetHasErrors: 'set-has-errors',
    UpdateCosmeticDate: 'update-cosmetic-date',
    UpdateCosmeticErrors: 'update-cosmetic-errors',
    UpdateMileage: 'update-mileage',
    UpdateIncidentOccured: 'update-incident-occured',
    UpdateDamageType: 'update-damage-type',
    UpdateDamageDepth: 'update-damage-depth',
    UpdateUploadedImages: 'update-uploaded-images',
    SaveCosmeticRequest: 'save-cosmetic-request',
    AddCosmeticRequest: 'add-cosmetic-request',
    UpdateDamageLength: 'update-damage-length',
    UpdateCosmeticStage: 'update-cosmetic-stage',
    UpdateRepairAddressSelected: 'set-repair-address-selected',
    SetRepairAddress: 'set-repair-address',
    UpdateCosmeticRequest: 'update-cosmetic-request',
    UpdateSelectedPanels: 'update-selected-panels',
    ScrollToAddress: 'scroll-to-address',
    ShowRepairRequestForm: 'show-repair-request-form',
    LoadingOnRequestSubmission: 'set-loading-request-submission',
    SetPermissionGranted: 'set-permission-granted',
    ShowCancelAlert: 'show-alert',
    DeleteCosmeticRequest: 'delete-cosmetic-request',
    UpdateDefaultDealerAddress: 'set-default-dealer-address'
} as const;

export const DamageTypes = {
    DentNoPaintDamage: 'Dent with no paint damage',
    DentPaintDamage: 'Dent with paint damage',
    Scratch: 'Scratch',
    StoneChip: 'Stone chip',
    Hail: 'Hail'
} as const;

export const DamageTypesExample = {
    CloseUpImage: 'Close up image',
    DistanceImage: 'Distance image'
} as const;

export const DamageDepth = {
    Yes: 'Yes',
    No: 'No'
} as const;

export const DamageLength = {
    UnderTen: 'Under 10cm',
    TenToFifteen: '10-15cm',
    FifteenToTwenty: '15-20cm',
    TwentyToTwentyFive: '20-25cm',
    TwentyFiveToThirty: '25-30cm',
    ThirtyToThirtyFive: '30-35cm',
    ThirtyFiveToFourty: '35-40cm',
    OverFourty: 'Over 40cm'
};

export enum Panels {
    Bonnet = 'Bonnet',
    FrontBumper = 'Front bumper',
    FrontDriverWing = 'Front driver wing',
    FrontPassengerWing = 'Front passenger wing',
    FrontDriverDoor = 'Front driver door',
    FrontPassengerDoor = 'Front passenger door',
    RearDriverDoor = 'Rear driver door',
    RearPassengerDoor = 'Rear passenger door',
    RearPassengerWing = 'Rear passenger wing',
    RearDriverWing = 'Rear driver wing',
    RearBumper = 'Rear bumper',
    Boot = 'Boot',
    PassengerSill = 'Passenger sill',
    DriverSill = 'Driver sill',
    Roof = 'Roof'
}
